
import { useSelector } from "react-redux";
import { IADPState } from "../typings/AppStateTypes";
import { environment } from "../util";
import TimeService from "../services/timeService";
import { useState } from "react";
import { useDedupEffect } from "@npd-ng/adp-component-library";
export function useMaintenanceCheck(redirectUrl: string) { 
    const state = useSelector(
      (state: { rootState: IADPState }) => state.rootState
    ); 
    const [underMaintenance, setUnderMainttenance] = useState(false);
    const isUnderMaintenance = async ()=>{
         if(state.sessionState.networkConnectionState === "Connected"){
          const onlineURL =`${environment.resolveENAEPDomain()}/api-student-data-services/v1/student-data-services/enaep/system-status`;
          const timeInSync = await TimeService.validateCurrentTime(
            onlineURL,state?.appState.configuration?.systemClockThreshold || 300000) 
          if(!timeInSync.passed && timeInSync.serverTime?.includes("UnderMaintenance")){
            setUnderMainttenance(true);
            return true;
           } 
          else {
            return false;
          }  
      } 
      else {
        return false;
      }
    } 
    useDedupEffect(() => {
        if(underMaintenance){
            window.location.replace(redirectUrl);
        }
    }, [underMaintenance]);
    return {isUnderMaintenance}
  }